var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33268 3.60626C8.33268 3.47709 8.51102 3.33293 8.74935 3.33293H11.2493C11.4877 3.33293 11.666 3.47709 11.666 3.60626V4.99959H8.33268V3.60626ZM17.4993 4.99959H16.666H13.3327V3.60626C13.3327 2.53626 12.3985 1.66626 11.2493 1.66626H8.74935C7.60018 1.66626 6.66602 2.53626 6.66602 3.60626V4.99959H3.33268H2.49935C2.04102 4.99959 1.66602 5.37543 1.66602 5.83293C1.66602 6.29126 2.04102 6.66626 2.49935 6.66626H3.33268V15.8329C3.33268 17.2121 4.45435 18.3329 5.83268 18.3329H14.166C15.5443 18.3329 16.666 17.2121 16.666 15.8329V6.66626H17.4993C17.9577 6.66626 18.3327 6.29126 18.3327 5.83293C18.3327 5.37543 17.9577 4.99959 17.4993 4.99959Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/TrashFilled.ff91a6b99acc7186ae8dd61fe748da4c.svg";
export { ForwardRef as ReactComponent };